import type { PmMarkConverter } from './../pm-converters/types';
import { Decoration_Type } from './../ricos-schema/legacy/wix/rich_content/v1';
import { isMaliciousUrl } from './../_shared/link/is-malicious-url';

export const linkConverter: PmMarkConverter = {
  fromPm: {
    type: Decoration_Type.LINK,
    convert: mark => {
      const { attrs } = mark;
      return [{ type: Decoration_Type.LINK, linkData: { ...attrs } }];
    },
  },
  toPm: {
    type: Decoration_Type.LINK,
    convert: decoration => {
      const { linkData } = decoration;
      return isMaliciousUrl(linkData?.link?.url || '')
        ? undefined
        : {
            type: Decoration_Type.LINK,
            attrs: {
              ...linkData,
            },
          };
    },
  },
};
